module.exports = __webpack_public_path__ + "static/media/sdms_img.d53e63f5.png";